/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3RewardNodeProvidersIdRequest = {
  id: number;
};

/** @internal */
export const GetApiV3RewardNodeProvidersIdRequest$inboundSchema: z.ZodType<
  GetApiV3RewardNodeProvidersIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.number().int(),
});

/** @internal */
export type GetApiV3RewardNodeProvidersIdRequest$Outbound = {
  id: number;
};

/** @internal */
export const GetApiV3RewardNodeProvidersIdRequest$outboundSchema: z.ZodType<
  GetApiV3RewardNodeProvidersIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3RewardNodeProvidersIdRequest
> = z.object({
  id: z.number().int(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3RewardNodeProvidersIdRequest$ {
  /** @deprecated use `GetApiV3RewardNodeProvidersIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3RewardNodeProvidersIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3RewardNodeProvidersIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3RewardNodeProvidersIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3RewardNodeProvidersIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3RewardNodeProvidersIdRequest$Outbound;
}

export function getApiV3RewardNodeProvidersIdRequestToJSON(
  getApiV3RewardNodeProvidersIdRequest: GetApiV3RewardNodeProvidersIdRequest,
): string {
  return JSON.stringify(
    GetApiV3RewardNodeProvidersIdRequest$outboundSchema.parse(
      getApiV3RewardNodeProvidersIdRequest,
    ),
  );
}

export function getApiV3RewardNodeProvidersIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3RewardNodeProvidersIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3RewardNodeProvidersIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3RewardNodeProvidersIdRequest' from JSON`,
  );
}
